<template>
  <!-- featured course -->
  <section class="featured-courses-section">
    <div class="container">
      <div class="section-header text-center">
        <span class="fw-medium text-secondary text-decoration-underline mb-2 d-inline-block">Materi Terbaru</span>
        <h2>Apa yang Baru di Sapta Learning?</h2>
        <p>
          Temukan modul pelatihan terbaru yang dirancang untuk meningkatkan kompetensi teknis Anda.
        </p>
      </div>
      <div class="feature-course-slider-2">
        <Carousel :settings="settings" :breakpoints="breakpoints">
          <Slide v-for="item in limitedCourses" :key="item.id">
            <div>
              <div class="course-item">
                <div class="course-img">
                  <router-link :to="{
                    name: 'CourseDetail',
                    params: { course_id: item.course_id },
                  }">
                    <img
                      :src="courseThumbnail(item)"
                      alt="img"
                      class="img-fluid"
                      @error="onThumbnailError"
                    />
                  </router-link>
                </div>
                <div class="pb-3 border-bottom mb-3 text-start">
                  <h5>
                    <router-link :to="{
                      name: 'CourseDetail',
                      params: { course_id: item.course_id },
                    }">{{
                      item.title
                    }}</router-link>
                  </h5>
                </div>
                <div class="d-flex align-items-center justify-content-between mb-0">
                  <div class="course-rating">
                    <span class="course-user"><a href="javascript:void(0);">
                        <img :src="authStore.currentUser
                          ? `${authStore.authUrl}/storage/photo/${authStore.userPhoto(item.instructor)}`
                          : require('@/assets/img/user/img-user.png')" alt="img" class="img-fluid" /></a></span>
                    <a href="javascript:void(0);">{{ userStore.userName(item.instructor) }}</a>
                  </div>
                  <div class="d-flex">
                    <router-link :to="{
                      name: 'CourseDetail',
                      params: { course_id: item.course_id },
                    }" class="btn buy-course-btn">Mulai Belajar</router-link>
                  </div>
                </div>

              </div>
            </div>
          </Slide>
          <template #addons>
            <Navigation />
          </template>
        </Carousel>
      </div>
      <div class="d-flex align-items-center justify-content-center">
        <router-link to="/course/course-list" class="btn btn-primary btn-md">Jelajahi Katalog Pelatihan</router-link>
      </div>
    </div>
  </section>
  <!-- /featured course -->

  <!-- community-to-learn -->
  <section class="community-to-learn">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-lg-6">
          <div class="section-header">
            <span class="fw-medium text-secondary text-decoration-underline mb-2 d-inline-block">Pembelajaran
              Lanjutan</span>
            <h2>Kolaborasi & Tumbuh Bersama Tim Sapta.</h2>
            <p>
              Kami berdedikasi untuk mentransformasi kompetensi internal dengan menyediakan berbagai modul berkualitas
              tinggi untuk seluruh level karyawan.
            </p>
          </div>
          <div class="community-item d-flex align-items-center">
            <span class="community-icon-1">
              <i class="isax isax-book-saved5"></i>
            </span>
            <div>
              <h5 class="mb-2">Belajar dari Mana Saja</h5>
              <p class="mb-0">
                Akses materi pelatihan secara fleksibel, memungkinkan Anda belajar di sela-sela waktu kerja atau di
                lapangan.
              </p>
            </div>
          </div>
          <div class="community-item d-flex align-items-center">
            <span class="community-icon-2">
              <i class="isax isax-bookmark5"></i>
            </span>
            <div>
              <h5 class="mb-2">Mentor Berpengalaman</h5>
              <p class="mb-0">
                Dapatkan bimbingan langsung dari para ahli dan senior yang memahami standar operasional perusahaan.
              </p>
            </div>
          </div>
          <div class="community-item d-flex align-items-center">
            <span class="community-icon-3">
              <i class="isax isax-chart-26"></i>
            </span>
            <div>
              <h5 class="mb-2">Kuasai Skill yang Dibutuhkan</h5>
              <p class="mb-0">
                Fokus pada pengembangan keterampilan teknis yang relevan dengan kebutuhan proyek dan operasional
                terkini.
              </p>
            </div>
          </div>
          <div class="d-flex align-items-center gap-2">
            <router-link to="/" class="btn btn-secondary btn-md">Mulai Belajar</router-link>
            <router-link to="/pages/become-an-instructor" class="btn btn-dark btn-md">Daftar Jadi Mentor</router-link>
          </div>
        </div>
        <div class="col-lg-6">
          <div class="community-img d-none d-lg-flex">
            <img src="@/assets/img/shapes/shape-5.png" alt="img" class="img-fluid community-img-01" />
            <img src="@/assets/img/shapes/shape-6.png" alt="img" class="img-fluid community-img-02" />
            <img src="@/assets/img/gallery/gallery-05.webp" alt="img" class="img-fluid community-img-03" />
            <img src="@/assets/img/gallery/gallery-06.webp" alt="img" class="img-fluid community-img-04" />
            <img src="@/assets/img/shapes/shape-7.svg" alt="img" class="img-fluid community-img-05" />
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- /community-to-learn -->
</template>

<script>
import HomeFeatured from "@/assets/json/home-featured-course.json";
import { Carousel, Navigation, Slide } from "vue3-carousel";
import "vue3-carousel/dist/carousel.css";
import { useCourseFetchStore } from "@/stores/course/course-fetch-store.js";
import { useAuthStore } from "@/stores/auth-store";
import { onMounted } from "vue";
import { useUserStore } from "@/stores/user/user-store.js";

const FALLBACK_THUMBNAIL = require("@/assets/img/fallback_image.jpg");

export default {
  components: {
    Carousel,
    Slide,
    Navigation,
  },
  data() {
    return {
      HomeFeatured: HomeFeatured,
    };
  },
  setup() {
    const courseFetchStore = useCourseFetchStore();
    const authStore = useAuthStore();
    const userStore = useUserStore();

    const courseThumbnail = (item) => {
      if (!item?.thumbnail) return FALLBACK_THUMBNAIL;
      return `${authStore.Url}/media/${item.thumbnail}`;
    };

    const onThumbnailError = (event) => {
      event.target.src = FALLBACK_THUMBNAIL;
    };

    onMounted(() => {
      courseFetchStore.fetchCourseList();
      userStore.fetchTeachers();
      userStore.fetchPrincipals();
    });
    return {
      courseFetchStore,
      authStore,
      userStore,
      courseThumbnail,
      onThumbnailError,
      // carousel settings
      settings: {
        itemsToShow: 1,
        snapAlign: "center",
      },
      breakpoints: {
        575: {
          itemsToShow: 1,
          snapAlign: "center",
        },
        767: {
          itemsToShow: 2,
          snapAlign: "center",
        },
        991: {
          itemsToShow: 3,
          snapAlign: "center",
        },
        1024: {
          itemsToShow: 4,
          snapAlign: "start",
        },
      },
    };
  },
  computed: {
    limitedCourses() {
      return (this.courseFetchStore.paginatedCourses || []).slice(0, 5)
    }
  },

};
</script>
